import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import syncFetch from 'sync-fetch';
import 'isomorphic-fetch';
import logger from '../logger.js';
import pkg from '../../package.json';
var corsEnabled = typeof location !== 'undefined' && typeof document !== 'undefined';
var userAgent = "Citation.js/".concat(pkg.version, " Node.js/").concat(process.version);

function normaliseHeaders(headers) {
  var result = {};
  var entries = headers instanceof Headers || headers instanceof syncFetch.Headers ? Array.from(headers) : Object.entries(headers);

  var _iterator = _createForOfIteratorHelper(entries),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
          name = _step$value[0],
          header = _step$value[1];

      result[name.toLowerCase()] = header.toString();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return result;
}

function parseOpts() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var reqOpts = {
    headers: {
      accept: '*/*'
    },
    method: 'GET',
    checkContentType: opts.checkContentType
  };

  if (userAgent && !corsEnabled) {
    reqOpts.headers['user-agent'] = userAgent;
  }

  if (opts.body) {
    reqOpts.method = 'POST';
    var isJson = typeof opts.body !== 'string';
    reqOpts.body = isJson ? JSON.stringify(opts.body) : opts.body;
    reqOpts.headers['content-type'] = isJson ? 'application/json' : 'text/plain';
  }

  if (opts.headers) {
    Object.assign(reqOpts.headers, normaliseHeaders(opts.headers));
  }

  return reqOpts;
}

function sameType(request, response) {
  if (!request.accept || request.accept === '*/*' || !response['content-type']) {
    return true;
  }

  var _response$contentTyp = response['content-type'].split(';')[0].trim().split('/'),
      _response$contentTyp2 = _slicedToArray(_response$contentTyp, 2),
      a = _response$contentTyp2[0],
      b = _response$contentTyp2[1];

  return request.accept.split(',').map(function (type) {
    return type.split(';')[0].trim().split('/');
  }).some(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        c = _ref2[0],
        d = _ref2[1];

    return (c === a || c === '*') && (d === b || d === '*');
  });
}

function checkResponse(response, opts) {
  var status = response.status,
      headers = response.headers;
  var error;

  if (status >= 400) {
    error = new Error("Server responded with status code ".concat(status));
  } else if (opts.checkContentType === true && !sameType(opts.headers, normaliseHeaders(headers))) {
    error = new Error("Server responded with content-type ".concat(headers.get('content-type')));
  }

  if (error) {
    error.status = status;
    error.headers = headers;
    error.body = response.body;
    throw error;
  }

  return response;
}

export function fetchFile(url, opts) {
  var reqOpts = parseOpts(opts);
  logger.http('[core]', reqOpts.method, url, reqOpts);
  var response = checkResponse(syncFetch(url, reqOpts), reqOpts);
  return response.text();
}
export function fetchFileAsync(_x, _x2) {
  return _fetchFileAsync.apply(this, arguments);
}

function _fetchFileAsync() {
  _fetchFileAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url, opts) {
    var reqOpts;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            reqOpts = parseOpts(opts);
            logger.http('[core]', reqOpts.method, url, reqOpts);
            return _context.abrupt("return", fetch(url, reqOpts).then(function (response) {
              return checkResponse(response, reqOpts);
            }).then(function (response) {
              return response.text();
            }));

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fetchFileAsync.apply(this, arguments);
}

export function setUserAgent(newUserAgent) {
  userAgent = newUserAgent;
}
export default fetchFile;